'use strict';
require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.string.iterator');
require('../../modules/es.symbol.iterator');
var WrappedWellKnownSymbolModule = require('../../internals/well-known-symbol-wrapped');

module.exports = WrappedWellKnownSymbolModule.f('iterator');



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/symbol/iterator.js
// module id = 345
// module chunks = 0